export const phoneCountries = [
  {
    code: 'ZZ',
    name: 'International',
    prefix: '+',
    flagUrl: 'default.svg',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    prefix: '+93',
    flagUrl: 'AF.svg',
  },
  {
    code: 'AX',
    name: 'Åland Islands',
    prefix: '+358-18',
    flagUrl: 'AX.svg',
  },
  {
    code: 'AL',
    name: 'Albania',
    prefix: '+355',
    flagUrl: 'AL.svg',
  },
  {
    code: 'DZ',
    name: 'Algeria',
    prefix: '+213',
    flagUrl: 'DZ.svg',
  },
  {
    code: 'AS',
    name: 'American Samoa',
    prefix: '+1-684',
    flagUrl: 'AS.svg',
  },
  {
    code: 'AD',
    name: 'Andorra',
    prefix: '+376',
    flagUrl: 'AD.svg',
  },
  {
    code: 'AO',
    name: 'Angola',
    prefix: '+244',
    flagUrl: 'AO.svg',
  },
  {
    code: 'AI',
    name: 'Anguilla',
    prefix: '+1-264',
    flagUrl: 'AI.svg',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    prefix: '+1-268',
    flagUrl: 'AG.svg',
  },
  {
    code: 'AR',
    name: 'Argentina',
    prefix: '+54',
    flagUrl: 'AR.svg',
  },
  {
    code: 'AM',
    name: 'Armenia',
    prefix: '+374',
    flagUrl: 'AM.svg',
  },
  {
    code: 'AW',
    name: 'Aruba',
    prefix: '+297',
    flagUrl: 'AW.svg',
  },
  {
    code: 'AC',
    name: 'Ascension Island',
    prefix: '+247',
    flagUrl: 'AC.svg',
  },
  {
    code: 'AU',
    name: 'Australia',
    prefix: '+61',
    flagUrl: 'AU.svg',
  },
  {
    code: 'AT',
    name: 'Austria',
    prefix: '+43',
    flagUrl: 'AT.svg',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    prefix: '+994',
    flagUrl: 'AZ.svg',
  },
  {
    code: 'BS',
    name: 'Bahamas',
    prefix: '+1-242',
    flagUrl: 'BS.svg',
  },
  {
    code: 'BH',
    name: 'Bahrain',
    prefix: '+973',
    flagUrl: 'BH.svg',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    prefix: '+880',
    flagUrl: 'BD.svg',
  },
  {
    code: 'BB',
    name: 'Barbados',
    prefix: '+1-246',
    flagUrl: 'BB.svg',
  },
  {
    code: 'BY',
    name: 'Belarus',
    prefix: '+375',
    flagUrl: 'BY.svg',
  },
  {
    code: 'BE',
    name: 'Belgium',
    prefix: '+32',
    flagUrl: 'BE.svg',
  },
  {
    code: 'BZ',
    name: 'Belize',
    prefix: '+501',
    flagUrl: 'GZ.svg',
  },
  {
    code: 'BJ',
    name: 'Benin',
    prefix: '+229',
    flagUrl: 'BJ.svg',
  },
  {
    code: 'BM',
    name: 'Bermuda',
    prefix: '+1-441',
    flagUrl: 'BM.svg',
  },
  {
    code: 'BT',
    name: 'Bhutan',
    prefix: '+975',
    flagUrl: 'BT.svg',
  },
  {
    code: 'BO',
    name: 'Bolivia',
    prefix: '+591',
    flagUrl: 'BO.svg',
  },
  {
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
    prefix: '+599',
    flagUrl: 'BQ.svg',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    prefix: '+387',
    flagUrl: 'BA.svg',
  },
  {
    code: 'BW',
    name: 'Botswana',
    prefix: '+267',
    flagUrl: 'BW.svg',
  },
  {
    code: 'BR',
    name: 'Brazil',
    prefix: '+55',
    flagUrl: 'BR.svg',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    prefix: '+246',
    flagUrl: 'IO.svg',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
    prefix: '+673',
    flagUrl: 'BN.svg',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    prefix: '+359',
    flagUrl: 'BG.svg',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    prefix: '+226',
    flagUrl: 'BF.svg',
  },
  {
    code: 'BI',
    name: 'Burundi',
    prefix: '+257',
    flagUrl: 'BI.svg',
  },
  {
    code: 'KH',
    name: 'Cambodia',
    prefix: '+855',
    flagUrl: 'KH.svg',
  },
  {
    code: 'CM',
    name: 'Cameroon',
    prefix: '+237',
    flagUrl: 'CM.svg',
  },
  {
    code: 'CA',
    name: 'Canada',
    prefix: '+1',
    flagUrl: 'CA.svg',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    prefix: '+238',
    flagUrl: 'CV.svg',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    prefix: '+1-345',
    flagUrl: 'KY.svg',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    prefix: '+236',
    flagUrl: 'CF.svg',
  },
  {
    code: 'TD',
    name: 'Chad',
    prefix: '+235',
    flagUrl: 'TD.svg',
  },
  {
    code: 'CL',
    name: 'Chile',
    prefix: '+56',
    flagUrl: 'CL.svg',
  },
  {
    code: 'CN',
    name: 'China',
    prefix: '+86',
    flagUrl: 'CN.svg',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    prefix: '+61',
    flagUrl: 'CX.svg',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    prefix: '+61',
    flagUrl: 'CC.svg',
  },
  {
    code: 'CO',
    name: 'Colombia',
    prefix: '+57',
    flagUrl: 'CO.svg',
  },
  {
    code: 'KM',
    name: 'Comoros',
    prefix: '+269',
    flagUrl: 'KM.svg',
  },
  {
    code: 'CG',
    name: 'Congo',
    prefix: '+242',
    flagUrl: 'CG.svg',
  },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
    prefix: '+243',
    flagUrl: 'CD.svg',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    prefix: '+682',
    flagUrl: 'CK.svg',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    prefix: '+506',
    flagUrl: 'CR.svg',
  },
  {
    code: 'CI',
    name: "Cote d'Ivoire",
    prefix: '+225',
    flagUrl: 'CI.svg',
  },
  {
    code: 'HR',
    name: 'Croatia',
    prefix: '+385',
    flagUrl: 'HR.svg',
  },
  {
    code: 'CU',
    name: 'Cuba',
    prefix: '+53',
    flagUrl: 'CU.svg',
  },
  {
    code: 'CW',
    name: 'Curaçao',
    prefix: '+599',
    flagUrl: 'CW.svg',
  },
  {
    code: 'CY',
    name: 'Cyprus',
    prefix: '+357',
    flagUrl: 'CY.svg',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    prefix: '+420',
    flagUrl: 'CZ.svg',
  },
  {
    code: 'DK',
    name: 'Denmark',
    prefix: '+45',
    flagUrl: 'DK.svg',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    prefix: '+253',
    flagUrl: 'DJ.svg',
  },
  {
    code: 'DM',
    name: 'Dominica',
    prefix: '+1-767',
    flagUrl: 'DM.svg',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    prefix: '+1-809',
    flagUrl: 'DO.svg',
  },
  {
    code: 'EC',
    name: 'Ecuador',
    prefix: '+593',
    flagUrl: 'EC.svg',
  },
  {
    code: 'EG',
    name: 'Egypt',
    prefix: '+20',
    flagUrl: 'EG.svg',
  },
  {
    code: 'SV',
    name: 'El Salvador',
    prefix: '+503',
    flagUrl: 'SV.svg',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    prefix: '+240',
    flagUrl: 'GQ.svg',
  },
  {
    code: 'ER',
    name: 'Eritrea',
    prefix: '+291',
    flagUrl: 'ER.svg',
  },
  {
    code: 'EE',
    name: 'Estonia',
    prefix: '+372',
    flagUrl: 'EE.svg',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    prefix: '+251',
    flagUrl: 'ET.svg',
  },
  {
    code: 'FK',
    name: 'Falkland Islands',
    prefix: '+500',
    flagUrl: 'FK.svg',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    prefix: '+298',
    flagUrl: 'FO.svg',
  },
  {
    code: 'FM',
    name: 'Federated States of Micronesia',
    prefix: '+691',
    flagUrl: 'FM.svg',
  },
  {
    code: 'FJ',
    name: 'Fiji',
    prefix: '+679',
    flagUrl: 'FJ.svg',
  },
  {
    code: 'FI',
    name: 'Finland',
    prefix: '+358',
    flagUrl: 'FI.svg',
  },
  {
    code: 'FR',
    name: 'France',
    prefix: '+33',
    flagUrl: 'FR.svg',
  },
  {
    code: 'GF',
    name: 'French Guiana',
    prefix: '+594',
    flagUrl: 'GF.svg',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    prefix: '+689',
    flagUrl: 'PF.svg',
  },
  {
    code: 'GA',
    name: 'Gabon',
    prefix: '+241',
    flagUrl: 'GA.svg',
  },
  {
    code: 'GM',
    name: 'Gambia',
    prefix: '+220',
    flagUrl: 'GM.svg',
  },
  {
    code: 'GE',
    name: 'Georgia',
    prefix: '+995',
    flagUrl: 'GE.svg',
  },
  {
    code: 'DE',
    name: 'Germany',
    prefix: '+49',
    flagUrl: 'DE.svg',
  },
  {
    code: 'GH',
    name: 'Ghana',
    prefix: '+233',
    flagUrl: 'GH.svg',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    prefix: '+350',
    flagUrl: 'GI.svg',
  },
  {
    code: 'GR',
    name: 'Greece',
    prefix: '+30',
    flagUrl: 'GR.svg',
  },
  {
    code: 'GL',
    name: 'Greenland',
    prefix: '+299',
    flagUrl: 'GL.svg',
  },
  {
    code: 'GD',
    name: 'Grenada',
    prefix: '+1-473',
    flagUrl: 'GD.svg',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    prefix: '+590',
    flagUrl: 'GP.svg',
  },
  {
    code: 'GU',
    name: 'Guam',
    prefix: '+1-671',
    flagUrl: 'GU.svg',
  },
  {
    code: 'GT',
    name: 'Guatemala',
    prefix: '+502',
    flagUrl: 'GT.svg',
  },
  {
    code: 'GG',
    name: 'Guernsey',
    prefix: '+44-1481',
    flagUrl: 'GG.svg',
  },
  {
    code: 'GN',
    name: 'Guinea',
    prefix: '+224',
    flagUrl: 'GN.svg',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    prefix: '+245',
    flagUrl: 'GW.svg',
  },
  {
    code: 'GY',
    name: 'Guyana',
    prefix: '+592',
    flagUrl: 'GY.svg',
  },
  {
    code: 'HT',
    name: 'Haiti',
    prefix: '+509',
    flagUrl: 'HT.svg',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
    prefix: '+379',
    flagUrl: 'VA.svg',
  },
  {
    code: 'HN',
    name: 'Honduras',
    prefix: '+504',
    flagUrl: 'HN.svg',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    prefix: '+852',
    flagUrl: 'HK.svg',
  },
  {
    code: 'HU',
    name: 'Hungary',
    prefix: '+36',
    flagUrl: 'HU.svg',
  },
  {
    code: 'IS',
    name: 'Iceland',
    prefix: '+354',
    flagUrl: 'IS.svg',
  },
  {
    code: 'IN',
    name: 'India',
    prefix: '+91',
    flagUrl: 'IN.svg',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    prefix: '+62',
    flagUrl: 'ID.svg',
  },
  {
    code: 'IR',
    name: 'Iran',
    prefix: '+98',
    flagUrl: 'IR.svg',
  },
  {
    code: 'IQ',
    name: 'Iraq',
    prefix: '+964',
    flagUrl: 'IQ.svg',
  },
  {
    code: 'IE',
    name: 'Ireland',
    prefix: '+353',
    flagUrl: 'IE.svg',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    prefix: '+44-1624',
    flagUrl: 'IM.svg',
  },
  {
    code: 'IL',
    name: 'Israel',
    prefix: '+972',
    flagUrl: 'IL.svg',
  },
  {
    code: 'IT',
    name: 'Italy',
    prefix: '+39',
    flagUrl: 'IT.svg',
  },
  {
    code: 'JM',
    name: 'Jamaica',
    prefix: '+1-876',
    flagUrl: 'JM.svg',
  },
  {
    code: 'JP',
    name: 'Japan',
    prefix: '+81',
    flagUrl: 'JP.svg',
  },
  {
    code: 'JE',
    name: 'Jersey',
    prefix: '+44-1534',
    flagUrl: 'JE.svg',
  },
  {
    code: 'JO',
    name: 'Jordan',
    prefix: '+962',
    flagUrl: 'JO.svg',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    prefix: '+7',
    flagUrl: 'KZ.svg',
  },
  {
    code: 'KE',
    name: 'Kenya',
    prefix: '+254',
    flagUrl: 'KE.svg',
  },
  {
    code: 'KI',
    name: 'Kiribati',
    prefix: '+686',
    flagUrl: 'KI.svg',
  },
  {
    code: 'XK',
    name: 'Kosovo',
    prefix: '+383',
    flagUrl: 'XK.svg',
  },
  {
    code: 'KW',
    name: 'Kuwait',
    prefix: '+965',
    flagUrl: 'KW.svg',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    prefix: '+996',
    flagUrl: 'KG.svg',
  },
  {
    code: 'LA',
    name: 'Laos',
    prefix: '+856',
    flagUrl: 'LA.svg',
  },
  {
    code: 'LV',
    name: 'Latvia',
    prefix: '+371',
    flagUrl: 'LV.svg',
  },
  {
    code: 'LB',
    name: 'Lebanon',
    prefix: '+961',
    flagUrl: 'LB.svg',
  },
  {
    code: 'LS',
    name: 'Lesotho',
    prefix: '+266',
    flagUrl: 'LS.svg',
  },
  {
    code: 'LR',
    name: 'Liberia',
    prefix: '+231',
    flagUrl: 'LR.svg',
  },
  {
    code: 'LY',
    name: 'Libya',
    prefix: '+218',
    flagUrl: 'LY.svg',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    prefix: '+423',
    flagUrl: 'LI.svg',
  },
  {
    code: 'LT',
    name: 'Lithuania',
    prefix: '+370',
    flagUrl: 'LT.svg',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    prefix: '+352',
    flagUrl: 'LU.svg',
  },
  {
    code: 'MO',
    name: 'Macao',
    prefix: '+853',
    flagUrl: 'MO.svg',
  },
  {
    code: 'MG',
    name: 'Madagascar',
    prefix: '+261',
    flagUrl: 'MG.svg',
  },
  {
    code: 'MW',
    name: 'Malawi',
    prefix: '+265',
    flagUrl: 'MW.svg',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    prefix: '+60',
    flagUrl: 'MY.svg',
  },
  {
    code: 'MV',
    name: 'Maldives',
    prefix: '+960',
    flagUrl: 'MV.svg',
  },
  {
    code: 'ML',
    name: 'Mali',
    prefix: '+223',
    flagUrl: 'ML.svg',
  },
  {
    code: 'MT',
    name: 'Malta',
    prefix: '+356',
    flagUrl: 'MT.svg',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    prefix: '+692',
    flagUrl: 'MH.svg',
  },
  {
    code: 'MQ',
    name: 'Martinique',
    prefix: '+596',
    flagUrl: 'MQ.svg',
  },
  {
    code: 'MR',
    name: 'Mauritania',
    prefix: '+222',
    flagUrl: 'MR.svg',
  },
  {
    code: 'MU',
    name: 'Mauritius',
    prefix: '+230',
    flagUrl: 'MU.svg',
  },
  {
    code: 'YT',
    name: 'Mayotte',
    prefix: '+262',
    flagUrl: 'YT.svg',
  },
  {
    code: 'MX',
    name: 'Mexico',
    prefix: '+52',
    flagUrl: 'MX.svg',
  },
  {
    code: 'MD',
    name: 'Moldova',
    prefix: '+373',
    flagUrl: 'MD.svg',
  },
  {
    code: 'MC',
    name: 'Monaco',
    prefix: '+377',
    flagUrl: 'MC.svg',
  },
  {
    code: 'MN',
    name: 'Mongolia',
    prefix: '+976',
    flagUrl: 'MN.svg',
  },
  {
    code: 'ME',
    name: 'Montenegro',
    prefix: '+382',
    flagUrl: 'ME.svg',
  },
  {
    code: 'MS',
    name: 'Montserrat',
    prefix: '+1-664',
    flagUrl: 'MS.svg',
  },
  {
    code: 'MA',
    name: 'Morocco',
    prefix: '+212',
    flagUrl: 'MA.svg',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    prefix: '+258',
    flagUrl: 'MZ.svg',
  },
  {
    code: 'MM',
    name: 'Myanmar',
    prefix: '+95',
    flagUrl: 'MM.svg',
  },
  {
    code: 'NA',
    name: 'Namibia',
    prefix: '+264',
    flagUrl: 'NA.svg',
  },
  {
    code: 'NR',
    name: 'Nauru',
    prefix: '+674',
    flagUrl: 'NR.svg',
  },
  {
    code: 'NP',
    name: 'Nepal',
    prefix: '+977',
    flagUrl: 'NP.svg',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    prefix: '+31',
    flagUrl: 'NL.svg',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    prefix: '+687',
    flagUrl: 'NC.svg',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    prefix: '+64',
    flagUrl: 'NZ.svg',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    prefix: '+505',
    flagUrl: 'NI.svg',
  },
  {
    code: 'NE',
    name: 'Niger',
    prefix: '+227',
    flagUrl: 'NE.svg',
  },
  {
    code: 'NG',
    name: 'Nigeria',
    prefix: '+234',
    flagUrl: 'NG.svg',
  },
  {
    code: 'NU',
    name: 'Niue',
    prefix: '+683',
    flagUrl: 'NU.svg',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    prefix: '+672',
    flagUrl: 'NF.svg',
  },
  {
    code: 'KP',
    name: 'North Korea',
    prefix: '+850',
    flagUrl: 'KP.svg',
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    prefix: '+389',
    flagUrl: 'MK.svg',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    prefix: '+1-670',
    flagUrl: 'MP.svg',
  },
  {
    code: 'NO',
    name: 'Norway',
    prefix: '+47',
    flagUrl: 'NO.svg',
  },
  {
    code: 'OM',
    name: 'Oman',
    prefix: '+968',
    flagUrl: 'OM.svg',
  },
  {
    code: 'PK',
    name: 'Pakistan',
    prefix: '+92',
    flagUrl: 'PK.svg',
  },
  {
    code: 'PW',
    name: 'Palau',
    prefix: '+680',
    flagUrl: 'PW.svg',
  },
  {
    code: 'PS',
    name: 'Palestine',
    prefix: '+970',
    flagUrl: 'PS.svg',
  },
  {
    code: 'PA',
    name: 'Panama',
    prefix: '+507',
    flagUrl: 'PA.svg',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    prefix: '+675',
    flagUrl: 'PG.svg',
  },
  {
    code: 'PY',
    name: 'Paraguay',
    prefix: '+595',
    flagUrl: 'PY.svg',
  },
  {
    code: 'PE',
    name: 'Peru',
    prefix: '+51',
    flagUrl: 'PE.svg',
  },
  {
    code: 'PH',
    name: 'Philippines',
    prefix: '+63',
    flagUrl: 'PH.svg',
  },
  {
    code: 'PL',
    name: 'Poland',
    prefix: '+48',
    flagUrl: 'PL.svg',
  },
  {
    code: 'PT',
    name: 'Portugal',
    prefix: '+351',
    flagUrl: 'PT.svg',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    prefix: '+1-787',
    flagUrl: 'PR.svg',
  },
  {
    code: 'QA',
    name: 'Qatar',
    prefix: '+974',
    flagUrl: 'QA.svg',
  },
  {
    code: 'RE',
    name: 'Reunion',
    prefix: '+262',
    flagUrl: 'RE.svg',
  },
  {
    code: 'RO',
    name: 'Romania',
    prefix: '+40',
    flagUrl: 'RO.svg',
  },
  {
    code: 'RU',
    name: 'Russia',
    prefix: '+7',
    flagUrl: 'RU.svg',
  },
  {
    code: 'RW',
    name: 'Rwanda',
    prefix: '+250',
    flagUrl: 'RW.svg',
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
    prefix: '+590',
    flagUrl: 'BL.svg',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    prefix: '+290',
    flagUrl: 'SH.svg',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    prefix: '+1-869',
    flagUrl: 'KN.svg',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    prefix: '+1-758',
    flagUrl: 'LC.svg',
  },
  {
    code: 'MF',
    name: 'Saint Martin (French Part)',
    prefix: '+590',
    flagUrl: 'MF.svg',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    prefix: '+508',
    flagUrl: 'PM.svg',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    prefix: '+1-784',
    flagUrl: 'VC.svg',
  },
  {
    code: 'WS',
    name: 'Samoa',
    prefix: '+685',
    flagUrl: 'WS.svg',
  },
  {
    code: 'SM',
    name: 'San Marino',
    prefix: '+378',
    flagUrl: 'SM.svg',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    prefix: '+239',
    flagUrl: 'ST.svg',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    prefix: '+966',
    flagUrl: 'SA.svg',
  },
  {
    code: 'SN',
    name: 'Senegal',
    prefix: '+221',
    flagUrl: 'SN.svg',
  },
  {
    code: 'RS',
    name: 'Serbia',
    prefix: '+381',
    flagUrl: 'RS.svg',
  },
  {
    code: 'SC',
    name: 'Seychelles',
    prefix: '+248',
    flagUrl: 'SC.svg',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    prefix: '+232',
    flagUrl: 'SL.svg',
  },
  {
    code: 'SG',
    name: 'Singapore',
    prefix: '+65',
    flagUrl: 'SG.svg',
  },
  {
    code: 'SX',
    name: 'Sint Maarten',
    prefix: '+1-721',
    flagUrl: 'SX.svg',
  },
  {
    code: 'SK',
    name: 'Slovakia',
    prefix: '+421',
    flagUrl: 'SK.svg',
  },
  {
    code: 'SI',
    name: 'Slovenia',
    prefix: '+386',
    flagUrl: 'SI.svg',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    prefix: '+677',
    flagUrl: 'SB.svg',
  },
  {
    code: 'SO',
    name: 'Somalia',
    prefix: '+252',
    flagUrl: 'SO.svg',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    prefix: '+27',
    flagUrl: 'ZA.svg',
  },
  {
    code: 'KR',
    name: 'South Korea',
    prefix: '+82',
    flagUrl: 'KR.svg',
  },
  {
    code: 'SS',
    name: 'South Sudan',
    prefix: '+211',
    flagUrl: 'SS.svg',
  },
  {
    code: 'ES',
    name: 'Spain',
    prefix: '+34',
    flagUrl: 'ES.svg',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    prefix: '+94',
    flagUrl: 'LK.svg',
  },
  {
    code: 'SD',
    name: 'Sudan',
    prefix: '+249',
    flagUrl: 'SD.svg',
  },
  {
    code: 'SR',
    name: 'Suriname',
    prefix: '+597',
    flagUrl: 'SR.svg',
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    prefix: '+47',
    flagUrl: 'SJ.svg',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
    prefix: '+268',
    flagUrl: 'SZ.svg',
  },
  {
    code: 'SE',
    name: 'Sweden',
    prefix: '+46',
    flagUrl: 'SE.svg',
  },
  {
    code: 'CH',
    name: 'Switzerland',
    prefix: '+41',
    flagUrl: 'CH.svg',
  },
  {
    code: 'SY',
    name: 'Syria',
    prefix: '+963',
    flagUrl: 'SY.svg',
  },
  {
    code: 'TW',
    name: 'Taiwan',
    prefix: '+886',
    flagUrl: 'TW.svg',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    prefix: '+992',
    flagUrl: 'TJ.svg',
  },
  {
    code: 'TZ',
    name: 'Tanzania',
    prefix: '+255',
    flagUrl: 'TZ.svg',
  },
  {
    code: 'TH',
    name: 'Thailand',
    prefix: '+66',
    flagUrl: 'TH.svg',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    prefix: '+670',
    flagUrl: 'TL.svg',
  },
  {
    code: 'TG',
    name: 'Togo',
    prefix: '+228',
    flagUrl: 'TG.svg',
  },
  {
    code: 'TK',
    name: 'Tokelau',
    prefix: '+690',
    flagUrl: 'TK.svg',
  },
  {
    code: 'TO',
    name: 'Tonga',
    prefix: '+676',
    flagUrl: 'TO.svg',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    prefix: '+1-868',
    flagUrl: 'TT.svg',
  },
  {
    code: 'TA',
    name: 'Tristan da Cunha',
    prefix: '+290',
    flagUrl: 'TA.svg',
  },
  {
    code: 'TN',
    name: 'Tunisia',
    prefix: '+216',
    flagUrl: 'TN.svg',
  },
  {
    code: 'TR',
    name: 'Turkey',
    prefix: '+90',
    flagUrl: 'TR.svg',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    prefix: '+993',
    flagUrl: 'TM.svg',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    prefix: '+1-649',
    flagUrl: 'TC.svg',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    prefix: '+688',
    flagUrl: 'TV.svg',
  },
  {
    code: 'UG',
    name: 'Uganda',
    prefix: '+256',
    flagUrl: 'UG.svg',
  },
  {
    code: 'UA',
    name: 'Ukraine',
    prefix: '+380',
    flagUrl: 'UA.svg',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    prefix: '+971',
    flagUrl: 'AE.svg',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    prefix: '+44',
    flagUrl: 'GN.svg',
  },
  {
    code: 'US',
    name: 'United States',
    prefix: '+1',
    flagUrl: 'US.svg',
  },
  {
    code: 'UY',
    name: 'Uruguay',
    prefix: '+598',
    flagUrl: 'UY.svg',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    prefix: '+998',
    flagUrl: 'UZ.svg',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    prefix: '+678',
    flagUrl: 'VU.svg',
  },
  {
    code: 'VE',
    name: 'Venezuela',
    prefix: '+58',
    flagUrl: 'VE.svg',
  },
  {
    code: 'VN',
    name: 'Vietnam',
    prefix: '+84',
    flagUrl: 'VN.svg',
  },
  {
    code: 'VG',
    name: 'Virgin Islands, British',
    prefix: '+1-284',
    flagUrl: 'VG.svg',
  },
  {
    code: 'VI',
    name: 'Virgin Islands, U.S.',
    prefix: '+1-340',
    flagUrl: 'VI.svg',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    prefix: '+681',
    flagUrl: 'WF.svg',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    prefix: '+212',
    flagUrl: 'EH.svg',
  },
  {
    code: 'YE',
    name: 'Yemen',
    prefix: '+967',
    flagUrl: 'YE.svg',
  },
  {
    code: 'ZM',
    name: 'Zambia',
    prefix: '+260',
    flagUrl: 'ZM.svg',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    prefix: '+263',
    flagUrl: 'ZW.svg',
  },
];
